import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarProcurement from "./SidebarProcurement";
import "../../../../styles/layout.css";
const AdminLayout = ({ children, module = "amtpl" }) => {
  console.log("module@@@",module);
  const handleSignOut = () => {
    console.log("Signing out...");
  };

  return (
    <div className="buyer-dashboard layout-css">
      
      {module === "amtpl_procurement" ? (
        <Header homemenu={true} onSignOut={handleSignOut} />
      ) : (
        <Header procurementmenu={true} onSignOut={handleSignOut} />
      )}
      <div className="display-flex">
        <div className="sidebar-css">
          {module === "amtpl_procurement" ? (
            <SidebarProcurement module={module} />
          ) : (
            <Sidebar module={module} />
          )}
        </div>
        <div className="content-css">
          {/* <Breadcrumbs/> */}
          {children}
        </div>
      </div>
    </div>
  );
};
export default AdminLayout;
